import { useStoreState } from '@ariakit/react'
import { FC } from 'react'
import styled from 'styled-components'

import { ProductCatalogEmbroideryPlacement } from '../../../../../../__generated__/graphql/catalog/graphql'
import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { useEmbroidery } from '../../../../../../containers/EmbroideryContainer/EmbroideryProvider'
import { PlacementSelector } from '../../../../Modal/primitives/selectors/PlacementSelector/PlacementSelector'
import { EmbroideryOptionWrapper as SharedEmbroideryOptionWrapper } from '../../../../Modal/primitives/shared-form-styles'
import { useValidPlacementOptionsForLegacyFlow } from '../../../../unorganized'
import { LogoFormContainer } from '../LogoFormContainer'

export const LogoPlacement: FC = () => {
  const { setCurrentPlacement, productEmbroideryConfig, selectedFormKind } = useEmbroidery()
  const { addLogoForm } = LogoFormContainer.useContainer()

  const {
    embroidery: {
      modal: {
        forms: { dtcLogoEmbroideryForm: fixtures },
      },
    },
  } = useTranslation()

  const logoPlacement = useStoreState(addLogoForm, s => s.values.logoPlacement)
  const errorMessage = useStoreState(addLogoForm, () =>
    addLogoForm.getFieldTouched('logoPlacement') ? addLogoForm.getError('logoPlacement') : undefined
  )

  const placements = useValidPlacementOptionsForLegacyFlow(
    productEmbroideryConfig?.options.logo?.placements
  )
  if (!placements) return null

  const handleSelectLogoPlacement = (placement: ProductCatalogEmbroideryPlacement) => {
    setCurrentPlacement(selectedFormKind, placement)
    addLogoForm.setValue('logoPlacement', placement)
  }

  return (
    <EmbroideryOptionWrapper>
      <PlacementSelector
        errorMessage={errorMessage ?? undefined}
        label={fixtures.logoPlacement}
        labelId={`${fixtures.logoPlacement}-id`}
        onSelectPlacement={handleSelectLogoPlacement}
        placementOptions={placements}
        selectedPlacementOption={logoPlacement}
      />
    </EmbroideryOptionWrapper>
  )
}

const EmbroideryOptionWrapper = styled(SharedEmbroideryOptionWrapper)`
  margin: ${({ theme }) => theme.spacing(6, 0, 6, 0)};
`
